import { purple } from '../colors';
export const newColor = (mode)=>{
    return mode === 'light' ? {
        main: purple[500],
        highContrast: purple[700],
        lowContrast: purple[100]
    } : {
        main: purple[400],
        highContrast: purple[100],
        lowContrast: purple[800]
    };
};

//# sourceMappingURL=new.js.map